/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReq2
 */
export interface UpdateReq2 {
    /**
     * 平台侧企业/店铺账号标识。
     * @type {string}
     * @memberof UpdateReq2
     */
    externalAccountId: string;
    /**
     * 新Access Key，为空表示保留原值。
     * @type {string}
     * @memberof UpdateReq2
     */
    credentialKey?: string;
    /**
     * 新Secret Key，为空表示保留原值。
     * @type {string}
     * @memberof UpdateReq2
     */
    credentialSecret?: string;
    /**
     * 凭证有效期，可选；为空或勾选无限期时不判断过期。
     * @type {string}
     * @memberof UpdateReq2
     */
    credentialExpireTime?: string;
    /**
     * 是否无限期；为true时清空已有到期时间。
     * @type {boolean}
     * @memberof UpdateReq2
     */
    credentialExpireUnlimited?: boolean;
}

/**
 * Check if a given object implements the UpdateReq2 interface.
 */
export function instanceOfUpdateReq2(value: object): value is UpdateReq2 {
    if (!('externalAccountId' in value) || value['externalAccountId'] === undefined) return false;
    return true;
}

export function UpdateReq2FromJSON(json: any): UpdateReq2 {
    return UpdateReq2FromJSONTyped(json, false);
}

export function UpdateReq2FromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReq2 {
    if (json == null) {
        return json;
    }
    return {
        
        'externalAccountId': json['externalAccountId'],
        'credentialKey': json['credentialKey'] == null ? undefined : json['credentialKey'],
        'credentialSecret': json['credentialSecret'] == null ? undefined : json['credentialSecret'],
        'credentialExpireTime': json['credentialExpireTime'] == null ? undefined : json['credentialExpireTime'],
        'credentialExpireUnlimited': json['credentialExpireUnlimited'] == null ? undefined : json['credentialExpireUnlimited'],
    };
}

export function UpdateReq2ToJSON(json: any): UpdateReq2 {
    return UpdateReq2ToJSONTyped(json, false);
}

export function UpdateReq2ToJSONTyped(value?: UpdateReq2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalAccountId': value['externalAccountId'],
        'credentialKey': value['credentialKey'],
        'credentialSecret': value['credentialSecret'],
        'credentialExpireTime': value['credentialExpireTime'],
        'credentialExpireUnlimited': value['credentialExpireUnlimited'],
    };
}

